export default __webpack_public_path__ + "static/media/KOD0120-min.fb85ae16.webp";